import { render, staticRenderFns } from "./FormRecepcion.vue?vue&type=template&id=3b87f065&"
import script from "./FormRecepcion.vue?vue&type=script&lang=js&"
export * from "./FormRecepcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports